<template>
  <div class="minister-list grid-parent">
    <div class="grid-wrapper" :style="getGridParentStyle()" >
      <div v-for="(item,index) in data" :key="index" :class="['grid-item', 'cabinet-member', checkCircleStatus(item.change_new_retire)]" :style="getGridItemStyle(item, index)">
          <div @click="openModel(item);" class="cabinet-member-photo">
            <img :src="getImgUrl(item.img_name)" :alt="item.img_name" />
            <div class="change_new_retire_text text_new">New MP</div>
            <div class="change_new_retire_text text_change">New NCMP</div>
            <!-- <div class="change_new_retire_text text_retire">Outgoing</div> -->
            <!-- <div class="change_new_retire_text text_new-office">New office-holder</div> -->
          </div>
          <div class="hide-in-mobile industry" :style="textColor(item.party)">
            {{item.party}}
          </div>
          <div class="cabinet-member-name">
            <span v-html="item.name" class="hide-in-mobile"></span>
            <span v-html="item.party" class="hide-above-mobile industry" :style="textColor(item.party)"></span>
            <!-- <span v-html="item.party" class="hide-above-mobile industry"></span> -->
            <span v-html="item.name_mobile" class="hide-above-mobile name-mobile"></span>
          </div>
          <div class="cabinet-member-more">
            {{item.main_designation}}
          </div>

      </div>
    </div>

  </div>
</template>

<script>
import {store} from './../ProjectStore.js'
export default {
  props: ['data'],
  data () {
    return {
      gridParent: {
        width: 1200,
        height: 350
      },
      gridItem: {
        width: 200,
        height: 350,
        padding: 10
      }, 
      styleObject: {
      color: 'red',
      fontSize: '13px'
      }
    }
  },
  mounted () {
    this.reCalculateParams()
    window.addEventListener('resize', this.reCalculateParams)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.reCalculateParams)
  },
  methods: {
    textColor (party){
      if(party === 'Arts' | party === 'Arts & Entertainment'){
        return {color: `#c7246b`}  // hot
      }else if(party === 'Business' | party === 'Business & Social Entrepreneurship'){
        return {color: `#ffd400` } 
      }else if(party === 'Politics & Civil Society'){
        return {color: `#56c8c3`} 
      }else if(party === 'Science & Tech'){
        return {color: `#29abe2`} 
      }else{
        return {color: `#96aaf2`} 
      }
    },
    getImgUrl (url) {
      if (url === '-' || url === '') {
        return require(`images/project/head/default.png`)
      }
      return require(`images/project/head/${url}.jpg`) // using pix in local folder
      // var imagesAssetFolder = store.imagesAssetFolder
      // return require(`${imagesAssetFolder}/candidates/${url}.jpg`)
      // return `${imagesAssetFolder}/${url.trim()}.jpg`
    },
    checkCircleStatus (status) {
      if (status && status !== '' && status !== '-') {
        return `circle_${status}`
      }
    },
    openModel (data) {
      store.modelData = data
      document.querySelector('body').style.overflow = 'hidden'
      // Analytics
      this.$analytics.getClient(store.projectName).track('click', {
        'popup': 'open',
        'mp': data.name
      })
    },
    getGridParentStyle () {
      return {
        // height: `${this.gridParent.height}px`
      }
    },
    getGridItemStyle (item, index) {
      return {
        // width: `${this.gridItem.width}px`
      }
    },
    reCalculateParams () {
      if (!this.data || this.data.length === 0) return
      // let height = this.data.length * this.gridItem.height
      // this.gridParent.height = height
      // let gridParentWidth = $(".grid-parent.grid_" + this.myUniqueId).width()
      // // set column width depending on screen size
      // if (gridParentWidth < 420) {
      //   this.detailsBoxHeight = 500
      //   this.item.width = 100
      //   this.item.height = 180
      // } else if(gridParentWidth < 768) {
      //   this.detailsBoxHeight = 500
      //   this.item.width = 150
      //   this.item.height = 230
      // } else {
      //   this.detailsBoxHeight = 400
      //   this.item.width = 200
      //   this.item.height = 350
      // }

      // if(gridParentWidth <= _this.item.width) {
      //   _this.itemsContainer.width = _this.item.width;
      //   _this.itemsContainer.height = _this.item.height * _this.data_array.length;
      //   if(_this.openItemIndex !== false) {
      //     _this.itemsContainerHeight = (_this.item.height * _this.data_array.length) + _this.detailsBoxHeight;
      //   } else {
      //     _this.itemsContainerHeight = _this.item.height * _this.data_array.length;
      //   }
      //   _this.columnCount = 1;
      // } else {
      //   let extraSpace = gridParentWidth % _this.item.width;
      //   _this.itemsContainer.width = gridParentWidth - extraSpace;
      //   _this.columnCount = _this.itemsContainer.width / _this.item.width;
      //   // Height of the container is
      //   // Remove the extra items in last row
      //   // Count total rows by dividing left data by columns, that's the number of rows
      //   // Add 1 to the row and multiply by the item height
      //   let totalItems = _this.data_array.length;
      //   let totalColumns = _this.columnCount;
      //   let extraItemsInLastRow = totalItems % totalColumns;
      //   let totalItemsInFullRow = totalItems - extraItemsInLastRow;
      //   let totalRows = totalItemsInFullRow / totalColumns;
      //   if(extraItemsInLastRow > 0) {
      //     totalRows++;
      //   }
      //   _this.itemsContainer.height = totalRows * _this.item.height;
      //   if(_this.openItemIndex !== false) {
      //     _this.itemsContainerHeight = (totalRows * _this.item.height) + _this.detailsBoxHeight;
      //   } else {
      //     _this.itemsContainerHeight = totalRows * _this.item.height;
      //   }
      // }
      // _this.itemsContainer.defaultHeight = _this.itemsContainer.height;
      // if (_this.openItemIndex !== false) {
      //   _this.itemsContainerHeight = _this.itemsContainer.height + _this.detailsBoxHeight;
      // } else {
      //   _this.itemsContainerHeight = _this.itemsContainer.height;
      // }
    }
  }
}
</script>

<style lang="scss">
.minister-list {
  max-width: 1024px;
  margin: 0 auto;
  &.grid-parent {
    margin-bottom: 40px;
    .grid-wrapper {
      position: relative;
      @include grid_template(1);
      @include breakpoint(300px) {
        @include grid_template(2);
      }
      @include breakpoint(375px) {
        @include grid_template(2);
      }
      @include breakpoint(440px) {
        @include grid_template(4);
      }
      @include breakpoint(640px) {
        @include grid_template(4);
      }
      @include breakpoint(1000px) {
        @include grid_template(5);
      }
      .grid-item {
        .cabinet-member-photo * {
          transition: 0.6s ease-in-out;
        }
        // position: absolute;
        // top: 0;
        // left: 0;
        // right: 0;
        // bottom: 0;
        // margin: 10px;
      }
    }
  }
  .cabinet-member {
    .cabinet-member-photo {
      position: relative;
      cursor: pointer;

      img {
        max-width: 100%;
        display: block;
        margin: 0 auto;
        border: 4px solid transparent;
        border-radius: 50%;
        box-sizing: border-box;
      }

      .change_new_retire_text {
        position: absolute;
        top: 15px;
        right: 0;
        font-family: $font-CuratorRegular;
        color: #fff;
        font-size: 15px;
        text-transform: uppercase;
        padding: 2px 10px;
        display: none;
        @media (max-width: 790px) and (min-width: $d_medium) {
          font-size: 70%;
        }

        @media (max-width: $d_medium - 1) {
          position: relative;
          // font-size: 12px;
          // padding: 5px 10px;
          font-size: 50%;
          padding: 5px 5%;
          top: 10px;
          left: 0;
          right: 0;
          text-align: center;
          margin-bottom: 20px;
        }

      }

    }
    .cabinet-member-name {
      font-family: $font-CuratorBold;
      font-size: 16px;
      margin: 8px 0 5px;
      line-height: 130%;

      @media (max-width: $d_medium - 1) {
        margin-top: 0;
        font-size: 60%;
        // font-size: 13px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .cabinet-member-more {
      margin-bottom: 0;
      font-family: $font-CuratorRegular;
      font-size: 16px;
      line-height: 1.2;

      @media (max-width: $d_medium - 1) {
        display: none;
      }
    }

    &.circle_new {
      // $item_color: #B20016;
      $item_color: #DF8526;
      .cabinet-member-photo {
        img {
          border-color: $item_color;
          box-shadow: inset 0 0 5px 15px $item_color;
        }
        .text_new {
          display: block;
          background-color: $item_color;
          white-space: nowrap;
        }
      }
    }
    &.circle_change {
      $item_color: #DF8526;
      .cabinet-member-photo {
        img {
          border-color: $item_color;
          box-shadow: inset 0 0 5px 15px $item_color;
        }
        .text_change {
          display: block;
          background-color: $item_color;
          white-space: nowrap;
        }
      }
    }
    &.circle_retire {
        $item_color: #5D9DD4;
        .cabinet-member-photo {
            img {
                border-color: $item_color;
                box-shadow: inset 0 0 5px 15px $item_color;
            }
            .text_retire {
                display: block;
                background-color: $item_color;
                white-space: nowrap;
            }
        }
    }
    &.circle_new-office {
        $item_color: #EF4223;
        .cabinet-member-photo {
            img {
                border-color: $item_color;
                box-shadow: inset 0 0 5px 15px $item_color;
            }
            .text_new-office {
                display: block;
                background-color: $item_color;
                white-space: nowrap;
                @media (max-width: $d_small) {
                  padding-left: 1%;
                  padding-right: 1%;
                }
            }
        }
    }
}
}
</style>
